/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgotpassworddesc2Inputs */

const zh_auth_forgotpassworddesc2 = /** @type {(inputs: Auth_Forgotpassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入您的邮箱地址，我们将发送密码重置链接。`)
};

const en_auth_forgotpassworddesc2 = /** @type {(inputs: Auth_Forgotpassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email address and we'll send you a link to reset your password.`)
};

const es_auth_forgotpassworddesc2 = /** @type {(inputs: Auth_Forgotpassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.`)
};

/**
* | output |
* | --- |
* | "Enter your email address and we'll send you a link to reset your password." |
*
* @param {Auth_Forgotpassworddesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_forgotpassworddesc2 = /** @type {((inputs?: Auth_Forgotpassworddesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgotpassworddesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_forgotpassworddesc2(inputs)
	if (locale === "en") return en_auth_forgotpassworddesc2(inputs)
	return es_auth_forgotpassworddesc2(inputs)
});
export { auth_forgotpassworddesc2 as "auth_forgotPasswordDesc" }